import { apiService } from '@/services/APIService';

export default {
  registration(params) {
    return apiService.post('/registration', params);
  },
  registrationNamesake(params) {
    return apiService.post('/registration-namesake', params);
  },

  registrationTrainer(params) {
    return apiService.post('/registration-trainer', params);
  },

  registrationExpert(params) {
    return apiService.post('/registration-expert', params);
  },

  getCaptcha() {
    return apiService.post('/captcha');
  },

  resetPassword(params) {
    return apiService.post('/auth/reset-password', params);
  },

  resetPasswordToken(params) {
    return apiService.put('/auth/reset-password', params);
  },
  getUsersForResetPassword(params) {
    return apiService.get('/auth/reset-password/users', params);
  },

  sendAuthCode(params) {
    return apiService.post('/auth/auth-code', params);
  },

  // авторизация через pfdo
  authWithPFDO(params) {
    return apiService.post('/auth/pfdo', params);
  },

  authUserWithCredentials(params) {
    return apiService.post('/auth', params);
  },

  /**
   * payload: { code: number }; // 6-ти значный код
   */
  authWithTelegram(payload) {
    return apiService.post('/public/telegram/auth-send-code', payload);
  },

  /**
   *  {
   *    email: string;
   *    municipality_id: number;
   *  };
   */
  registerOrganizationConfirmEmail(payload) {
    return apiService.post('/registration-organization/confirm-email', payload);
  },

  /**
   *  {
   *    username: string;
   *    password: string;
   *    password_confirmation: string;
   *    full_name: string;
   *    short_name: string;
   *    ground: number;
   *    head_full_name: string;
   *    contact_full_name: string;
   *    fact_address: string;
   *    legal_address: string;
   *    inn: string;
   *    token: string;
   *  };
   */
  registerOrganization(payload) {
    return apiService.post('/registration-organization', payload);
  },
};
